/* global BACKEND_DOMAIN */

// Host half of the API origin the SPA's own HTTP client talks to.
// icarus-core's `useApi()` axios instance is created with
// `baseURL: BACKEND_DOMAIN` (webpack DefinePlugin, from .env
// `BACKEND_DOMAIN__{DEVELOPMENT,PRODUCTION}`), so this is by construction
// the origin that serves `/api/v1/...` — same source `installerStatus.js`
// uses for its pre-boot fetch.
//
// Why it exists: the enrolment UI renders copy-paste
// `luna adopt <domain> <key>` commands, and that `<domain>` MUST be the API
// host — the CLI prepends `https://` and POSTs
// `/api/v1/servers/adopt-requests` against it (luna-node
// `src/agent/adopt.ts`). Pasting the SPA host instead returns the SPA
// catch-all's HTML and the CLI dies with "Expected a JSON response but
// got: <!doctype html>..." — which bit two real adoptions (demeter
// 2026-07-18, eunomia 2026-07-19) back when the UI only showed the generic
// `<domain>` placeholder. Always render the real host, never a placeholder.

export default function apiHost() {
  // DefinePlugin substitutes a string literal; when the env var is missing
  // that literal is the string "undefined" — treat it like absent and fall
  // back to the SPA's own origin (dev serves both halves off one host).
  const configured = typeof BACKEND_DOMAIN === 'string' && BACKEND_DOMAIN && BACKEND_DOMAIN !== 'undefined'
    ? BACKEND_DOMAIN
    : window.location.origin;

  try {
    // `host` (not `hostname`) keeps any non-default port — the CLI happily
    // takes `host:port` since it only prepends the scheme.
    return new URL(configured).host;
  } catch {
    // Not URL-parseable (e.g. a bare host in the env) — strip any scheme
    // and path by hand.
    return configured.replace(/^[a-z][a-z0-9+.-]*:\/\//i, '').split('/')[0];
  }
}
